import { NotifiableProduct } from "@nova/constants"
import { z } from "zod"
import { MobilePlatformSchema } from "../mobile/app-config"

export const PushTokensRequestSchema = z.object({
    token: z.string(),
    os: MobilePlatformSchema,
})

export type PushTokensRequest = z.infer<typeof PushTokensRequestSchema>

export const fcmRegistrationRecordSchema = z.object({
    fcm_token: z.string(),
    user_id: z.guid(),
    product: z.enum(NotifiableProduct),
    os: MobilePlatformSchema,
    created_at: z.string(),
    updated_at: z.string(),
})

export const fcmRegistrationSchema = fcmRegistrationRecordSchema.transform((r) => ({
    fcmToken: r.fcm_token,
    userId: r.user_id,
    product: r.product,
    os: r.os,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
}))

export type FcmRegistrationRecord = z.infer<typeof fcmRegistrationRecordSchema>
export type FcmRegistration = z.infer<typeof fcmRegistrationSchema>
